var shape={'borderRadius':0x4};export default shape;